import { Box, Typography } from "@mui/material";

/**
 * Reusable section title with optional overline, decorative divider, and subtitle.
 *
 * Props:
 *  - overline: small uppercase text above title
 *  - title: main heading
 *  - subtitle: paragraph below
 *  - align: "center" | "left"
 *  - light: true for white/gold text (dark backgrounds)
 */
const SectionTitle = ({ overline, title, subtitle, align = "center", light = false }) => {
  return (
    <Box sx={{ textAlign: align, mb: { xs: 5, md: 7 } }}>
      {overline && (
        <Typography
          sx={{
            fontSize: "0.68rem",
            letterSpacing: "0.3em",
            textTransform: "uppercase",
            fontWeight: 700,
            color: "secondary.main",
            mb: 1.5,
            display: "block",
          }}
        >
          {overline}
        </Typography>
      )}

      <Typography
        variant="h2"
        sx={{
          color: light ? "#fff" : "text.primary",
          fontSize: { xs: "1.9rem", md: "2.5rem" },
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          mb: 2,
          lineHeight: 1.2,
        }}
      >
        {title}
      </Typography>

      {/* Gold decorative divider */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: align === "center" ? "center" : "flex-start",
          gap: 1,
          mb: subtitle ? 3 : 0,
        }}
      >
        <Box sx={{ width: 50, height: 1, backgroundColor: light ? "rgba(201,168,76,0.4)" : "rgba(201,168,76,0.3)" }} />
        <Box sx={{ width: 6, height: 6, backgroundColor: "secondary.main", transform: "rotate(45deg)" }} />
        <Box sx={{ width: 50, height: 1, backgroundColor: light ? "rgba(201,168,76,0.4)" : "rgba(201,168,76,0.3)" }} />
      </Box>

      {subtitle && (
        <Typography
          variant="body1"
          sx={{
            color: light ? "rgba(255,255,255,0.7)" : "text.secondary",
            maxWidth: 600,
            mx: align === "center" ? "auto" : 0,
            lineHeight: 1.85,
            fontSize: "0.97rem",
            mt: 2,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default SectionTitle;